import O1HD from "../../../../engines/gameEngine";
import data_control from "../../../../engines/libs/data_control";
import { NormalStockI, NormalStockPriceI } from "../../manager/DefineInterface";
import StockPutInPrefab from "./StockPutInPrefab ";

const { ccclass, property } = cc._decorator;

@ccclass
export default class StockSellItem extends cc.Component {
    @property(cc.Label)
    stockName: cc.Label = null

    @property(cc.Label)
    stockPrice: cc.Label = null

    @property(cc.Label)
    stockPercentage: cc.Label = null

    @property(cc.Label)
    stockBuyPrice: cc.Label = null

    @property(cc.Label)
    stockCount: cc.Label = null

    stockPriceItem: NormalStockPriceI
    stockItem: NormalStockI

    redClolor: cc.Color = new cc.Color(246, 104, 48)
    greedClolor: cc.Color = new cc.Color(61, 255, 81)

    onBuyBtn() {
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        O1HD.emit(StockPutInPrefab.OPEN_BUY_STOCK_PREFAB, this.stockPriceItem, false)
    }

    onSellBtn() {
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        O1HD.emit(StockPutInPrefab.OPEN_SELL_STOCK_PREFAB, this.stockPriceItem, this.stockItem)
    }

    bindData(stockPriceItem: NormalStockPriceI, stockItem: NormalStockI) {
        this.stockPriceItem = stockPriceItem
        this.stockItem = stockItem
        this.stockName.string = stockItem.name
        if (stockItem.name.length == 4) {
            this.stockName.node.width = 60
        }else{
            this.stockName.node.width = 80
        }
        this.stockPrice.string = data_control.getNumberFormat(stockPriceItem.price)
        this.stockPercentage.string = (100 * stockPriceItem.percentage).toFixed(1) + "%"
        this.stockBuyPrice.string = data_control.getNumberFormat(stockItem.buyPrice)
        this.stockCount.string = stockItem.count.toString()

        if (stockPriceItem.percentage >= 0) {
            this.stockName.node.color = this.redClolor
            this.stockPrice.node.color = this.redClolor
            this.stockPercentage.node.color = this.redClolor
            this.stockBuyPrice.node.color = this.redClolor
            this.stockCount.node.color = this.redClolor
        } else {
            this.stockName.node.color = this.greedClolor
            this.stockPrice.node.color = this.greedClolor
            this.stockPercentage.node.color = this.greedClolor
            this.stockBuyPrice.node.color = this.greedClolor
            this.stockCount.node.color = this.greedClolor
        }
    }
}
